const KEY = (id: string | number) => `ikompete-eval-instructions-seen-${id}`;

function defaultStorage(): Storage | null {
  try { return window.localStorage; } catch { return null; }
}

/** True the first time a judge opens this competition's evaluation page in this browser. */
export function shouldOpenInstructions(competitionId: string | number, storage: Storage | null = defaultStorage()): boolean {
  if (!storage) return false;
  try {
    if (storage.getItem(KEY(competitionId))) return false;
    storage.setItem(KEY(competitionId), '1');
    return true;
  } catch {
    return false;
  }
}
